import { Box } from "@twilio-paste/core/box";
import {
  WiseOwlBlock,
  WiseOwlBlockType,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";
import { ReactElement } from "react";
import {
  MessageRenderer,
  ButtonGroup,
  LinkGroup,
  PromptSuggestionGroup,
  ToolCallRenderer,
  ToolCallStatusLine,
} from "./sub";

export interface BlockRendererProps {
  blocks: WiseOwlBlock[];
}

const getRendererForBlock = (block: WiseOwlBlock) => {
  switch (block.type) {
    case WiseOwlBlockType.Message:
      return <MessageRenderer block={block} />;
    case WiseOwlBlockType.ButtonGroup:
      return <ButtonGroup block={block} />;
    case WiseOwlBlockType.LinkGroup:
      return <LinkGroup block={block} />;
    case WiseOwlBlockType.PromptSuggestionGroup:
      return <PromptSuggestionGroup block={block} />;
    case WiseOwlBlockType.ToolCall:
      return <ToolCallRenderer block={block} />;
    case WiseOwlBlockType.ToolCallStatusLine:
      return <ToolCallStatusLine block={block} />;
    // stub
    case WiseOwlBlockType.SubmitTicketForm:
      return <></>;
    default:
      // Throws a build time error if this switch is not exhaustive
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-case-declarations
      const _exhaustiveCheck: never = block;
  }
};

const BlockRenderer = ({ blocks }: BlockRendererProps): ReactElement => {
  return (
    <Box>
      {blocks.map((block, index) => (
        <Box
          key={`${block.type}-${index}`}
          paddingLeft={
            block.type === WiseOwlBlockType.Message ||
            block.type === WiseOwlBlockType.PromptSuggestionGroup
              ? "space0"
              : "space120"
          }
        >
          <Box marginBottom="space30"> {getRendererForBlock(block)}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default BlockRenderer;
